import {
	FormControl,
	IconButton,
	InputLabel,
	Link,
	StackProps,
	TextField,
} from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Stack from '@mui/material/Stack';
import { CloudArrowUp as CloudArrowUpIcon } from '@phosphor-icons/react/dist/ssr/CloudArrowUp';
import { Question } from '@phosphor-icons/react/dist/ssr/Question';
import { useFormik } from 'formik';

import { DataImportInfoForm, DataImportInfoFormProps } from '../info-form';

export type DataImportWMSFormValues = {
	url: string;
};

type Props = StackProps & {
	form: ReturnType<typeof useFormik<DataImportWMSFormValues>>;
	infoForm: DataImportInfoFormProps['form'];
	onSave: () => void;
	onConnect: () => void;
	showInfo: boolean;
};

export const DataImportWMSUpload = ({
	form,
	infoForm,
	onSave,
	onConnect,
	showInfo,
}: Props) => {
	return (
		<Card>
			<CardHeader
				avatar={
					<Avatar>
						<CloudArrowUpIcon fontSize="var(--Icon-fontSize)" />
					</Avatar>
				}
				title="Web Map Service"
				action={
					<Link
						href={
							'https://help.mangomap.com/hc/en-us/articles/360022069732-Adding-a-Web-Map-Service-WMS'
						}
						target="_blank"
					>
						<IconButton>
							<Question />
						</IconButton>
					</Link>
				}
			/>
			<CardContent>
				<Stack spacing={3}>
					{showInfo ? (
						<DataImportInfoForm form={infoForm} />
					) : (
						<FormControl>
							<InputLabel>WMS GetCapabilities URL</InputLabel>
							<TextField
								{...form.getFieldProps('url')}
								error={!!form.errors.url}
								helperText={form.errors.url}
								placeholder="https://server.com?service=WMS"
							/>
						</FormControl>
					)}
				</Stack>
			</CardContent>
			<CardActions sx={{ justifyContent: 'flex-end' }}>
				{showInfo ? (
					<>
						<Button color="secondary">Cancel</Button>
						<Button variant="contained" onClick={onSave}>
							Save
						</Button>
					</>
				) : (
					<Button variant="contained" onClick={onConnect}>
						Connect
					</Button>
				)}
			</CardActions>
		</Card>
	);
};
